<template>
  <div class="testpage">
    <div class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-size-1">Test Page</h1>        
        </div>
      </div>
    </div>
    <div class="container testpage-main has-text-centered">
      <br/>
      <div class="flipper">
        <div class="flipper-panel">
            <div class="top">&nbsp;</div>
            <div class="bottom">&nbsp;</div>
        </div>
        <div class="flipper-panel">
            <div class="top">&nbsp;</div>
            <div class="bottom">&nbsp;</div>
        </div>
        <div class="flipper-panel">
            <div class="top">&nbsp;</div>
            <div class="bottom">&nbsp;</div>
        </div>
        <div class="flipper-panel">
            <div class="top">&nbsp;</div>
            <div class="bottom">&nbsp;</div>
        </div>
        <div class="flipper-panel">
            <div class="top">&nbsp;</div>
            <div class="bottom">&nbsp;</div>
        </div>
        <div class="flipper-panel">
            <div class="top">&nbsp;</div>
            <div class="bottom">&nbsp;</div>
        </div>
        <div class="flipper-panel">
            <div class="top">&nbsp;</div>
            <div class="bottom">&nbsp;</div>
        </div>
        <div class="flipper-panel">
            <div class="top">&nbsp;</div>
            <div class="bottom">&nbsp;</div>
        </div>
        <div class="flipper-panel">
            <div class="top">&nbsp;</div>
            <div class="bottom">&nbsp;</div>
        </div>
        <div class="flipper-panel">
            <div class="top">&nbsp;</div>
            <div class="bottom">&nbsp;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .hero {
    background-color: black;
  }
  .testpage-main {
    color: white;
    font-family: Verdana;
    height: 1000px;
  }
  p {
      color: white !important;
  }

.flipper {
    display: flex;
    gap: 5px;
    margin: 25px;
}

.flipper-panel {
    position: relative;
    width: 50px;
    height: 100px;
    perspective: 500px;
}

.flipper-panel .top,
.flipper-panel .bottom {
    position: absolute;
    width: 100%;
    height: 50%;
    background: black;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    backface-visibility: hidden;
    transform-origin: bottom;
}

.flipper-panel .bottom {
    transform-origin: top;
    transform: rotateX(90deg);
}

.flipper-panel.flip .top {
    animation: flip-top 0.6s forwards;
}

.flipper-panel.flip .bottom {
    animation: flip-bottom 0.6s forwards;
}

@keyframes flip-top {
    0% {
        transform: rotateX(0deg);
    }
    100% {
        transform: rotateX(-90deg);
    }
}

@keyframes flip-bottom {
    0% {
        transform: rotateX(90deg);
    }
    100% {
        transform: rotateX(0deg);
    }
}
</style>

<script>
export default {
name: 'testpage',
  components : {
  },
  computed: {
  },
  data () {
      return {
        flipped: false
      }
  },
  methods:{
    flipPanel: function(panel, newChar) {
      const top = panel.querySelector('.top');
      const bottom = panel.querySelector('.bottom');

      // Set the new character on the bottom half
      bottom.textContent = newChar;

      // Add the flip class to start the animation
      panel.classList.add('flip');

      // Wait for animation to complete, then reset
      setTimeout(() => {
          top.textContent = newChar; // Update the top character
          panel.classList.remove('flip'); // Remove the animation class
      }, 600); // Match the animation duration
    },
    start: function () {

      // Example usage
      const panels = document.querySelectorAll('.flipper-panel');
      let chars = ['F', 'L', 'I', 'P', 'P', 'E', 'R']; // Characters to flip through

      let currentIndex = 0;

      setInterval(() => {
          panels.forEach(panel => {
              this.flipPanel(panel, chars[currentIndex % chars.length]);
          });
          currentIndex++;
      }, 2000); // Flip every 2 seconds

    }
  },
  mounted(){
    this.start();
  }
}
</script>
